import styled from "styled-components";
import CryptidCard from "./shared/cryptidCard";
import WarningIcon from "../assets/icons/warning.png";
import UpgraderResultBg from "../assets/images/background/upgradeResultBg.png";
import {PrimaryButton} from "../components/styled"
import Lottie from "lottie-react";
import ConfettiAnimation from "../assets/animations/confetti.json"
import CardBackLightAnimation from "../assets/animations/card_back_light.json"
import { floatCard } from "./styled/animations";

const UpgradeResultModalContent = ({ cryptid, result, closeSheet}) => {
    if(!cryptid) return null;
    return (
        <Container>
            {result && <Lottie  style={{position: "absolute", width:"100%"}} animationData={ConfettiAnimation}/>}
            <Lottie  style={{position: "absolute", width:"100%",height:"100%"}} animationData={CardBackLightAnimation}/>
            <ContentContainer success={result}>
            <CardContainer success={result}>
                <CryptidCard cryptid={cryptid} inDeck/>
            </CardContainer>
            {!result && <Warning src={WarningIcon} />}
            </ContentContainer>
            <PrimaryButton style={{width:"50%"}} onClick={closeSheet}>Done</PrimaryButton>
        </Container>
    );
};
const Container = styled.div`
    display:flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 10px;
    gap: 8px;
    max-height: 80vh;
    padding-bottom: 34px;
    overflow-y: auto;
`
const ContentContainer = styled.div`
    width: 100%;
    // background-image: ${props => props?.success ? `url(${UpgraderResultBg})` : "none"};
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-block: 10px
`
const Warning = styled.img`
    position: absolute;
    bottom: 25%;
    right: 12%;
    z-index: 1;
`
const CardContainer = styled.div`
    width: 60%;
    height: auto;
    aspect-ratio: 859/1320;
    border-radius: 15px;
    background-color:#FFFFFF1A;
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
    transform: scale(0.5);
    filter:${props => props?.success ? "none" : "grayscale(100%)"};
    animation: ${floatCard} 4s ease-in-out infinite;
`
export default UpgradeResultModalContent;